import type { InvoiceQuerySchema } from '@/_pages/invoices/shared/schemas';

export type InvoiceDetailsPanelProps = {
  hasSelection: boolean;
  selectedInvoice: InvoiceQuerySchema | null;
  isLoading: boolean;
  isError: boolean;
};

export type DetailsTab = 'general' | 'detail' | 'notes';

export type InvoiceAgreementLink = {
  id: number;
  agreementId: string;
};

export const INVOICE_DETAILS_TABS: ReadonlyArray<{ key: DetailsTab; label: string }> = [
  { key: 'general', label: 'General' },
  { key: 'detail', label: 'Detail' },
  { key: 'notes', label: 'Notes' },
];
